'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixQuoteMediaMarketRates displays interest rates, to
     * be used on the Markets page of TheStreet.
     *
     * @example
     *  <phoenix-quote-media-market-rates>
     *  </phoenix-quote-media-market-rates>
     */
    class PhoenixQuoteMediaMarketRates extends pageClass.PhoenixElement {
        connectedCallback() {
            super.connectedCallback();
            const rateConfig = {
                lang: 'en',
                modalParams: {
                    chfill: 'eeeeee',
                    chfill2: '0071bb',
                    chln: '00578e',
                    chscale: '1y',
                    chcon: 'on',
                    chfrmon: 'off',
                    chtype: 'Mountain',
                    chbgch: 'ffffff',
                    chgrd: 'cccccc',
                    chbdr: 'cccccc',
                    chxyc: '666666',
                    chdon: 'off',
                    chton: 'off',
                    chwid: '400',
                    chfnts: '10',
                    chhig: '200',
                },
                topChartParams: {
                    chfill: 'eeeeee',
                    chfill2: '0071bb',
                    chln: '00578e',
                    chscale: '1y',
                    chfnts: '10',
                    chcon: 'on',
                    chfrmon: 'off',
                    chtype: 'Mountain',
                    chbgch: 'ffffff',
                    chgrd: 'cccccc',
                    chbdr: 'cccccc',
                    chxyc: '666666',
                    chdon: 'off',
                    chton: 'off',
                    chwid: '500',
                    chhig: '250',
                },
                clickAction: 'modal',
                topChartSymbols: '!USINF,!TB4W,!COSI',
                topChartSymbolscs: '!BANK:CA,!PRIME:CA,!V80691336',
                country: 'US',
            };
            this._render(rateConfig);
        }

        _render(config) {
            let qmodConfig = JSON.stringify(config);
            this.innerHTML = `<div data-qmod-tool="marketrates"
            data-qmod-params=${qmodConfig}
            class="qtool">`;
        }
    }

    window.customElements.define('phoenix-quote-media-market-rates', PhoenixQuoteMediaMarketRates);
});
